module.exports = __webpack_public_path__ + "ab877ff9eaf8296c67067da0f620ab31.pdf";